import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#1a518a'
        },
        secondary: {
            main: '#eeeeee',
            contrastText: '#000',
        }
    },
    colors: {
        primary: {
            '500': '#0A54A2',
            '400': '#6EA0D7',
            '300': '#AFC6DF',
            '200': '#E6EDF5',
            '100': '#F8FAFC',
        },
        secondary: {
            '500': '#3A3A3A',
            '400': '#545454',
            '300': '#878787',
            '200': '#A9A9A9',
            '100': '#DCDCDC',
        },
        labels: {
            green: {
                '200': '#48D960',
                '100': '#91E89F'
            },
            yellow: {
                '200': '#F3D041',
                '100': '#F7E28D'
            },
            red: {
                '200': '#EE0F0F',
                '100': '#F46F6F'
            }
        }
    },
    buttons: {
        primary: {
            default: {
                border: '#0A54A2',
                background: '#0A54A2',
                text: '#FFFFFF',
                svg: '#6EA0D7'
            },
            hover: {
                border: '#2265AB',
                background: '#2265AB',
                text: '#FFFFFF',
                svg: '#6EA0D7'
            },
            active: {
                border: '#073B72',
                background: '#073B72',
                text: '#FFFFFF',
                svg: '#6EA0D7'
            },
            disabled: {
                border: '#84A9D0',
                background: '#84A9D0',
                text: '#B5CBE3',
                svg: '#B5CBE3'
            }
        },
        secondary: {
            default: {
                border: '#E6EDF5',
                background: '#FFFFFF',
                text: '#0A54A2',
                svg: '#6EA0D7'
            },
            hover: {
                border: '#E6EDF5',
                background: '#E6EDF5',
                text: '#0A54A2',
                svg: '#6EA0D7'
            },
            active: {
                border: '#B5CBE3',
                background: '#EDF2F8',
                text: '#0A54A2',
                svg: '#6EA0D7'
            },
            disabled: {
                border: '#E6EDF5',
                background: '#FFFFFF',
                text: '#CCCCCC',
                svg: '#CCCCCC'
            }
        },
        tertiary: {
            default: {
                border: '#FFFFFF',
                background: '#FFFFFF',
                text: '#656565',
                svg: '#656565'
            },
            hover: {
                border: '#E6EDF5',
                background: '#E6EDF5',
                text: '#656565',
                svg: '#656565'
            },
            active: {
                border: '#AFC6DF',
                background: '#EDF2F8',
                text: '#545454',
                svg: '#656565'
            },
            disabled: {
                border: '#E6EDF5',
                background: '#FFFFFF',
                text: '#EDEDED',
                svg: '#EDEDED'
            }
        }
    },
    inputfields: {
        select: {
            menu: {
                border: '#E6EDF5'
            },
            item: {
                hover: '#F7F9FC'
            }
        }
    }
});

export default theme;